import { combineReducers } from "redux";
import AuthReducer from "./auth.reducer";
import NumberManagerReducer from "./numberManager.reducer";
import SupervisorReducer from "./supervisor.reducer";
import SupervisorQueueReducer from "./supervisorQueues.reducer";
import ActiveSupervisorQueueReducer from "./activeSuperVisorQueue.reducer";
import smsReducer from "./sms.reducer";
import ReceptionSockReducer from "./reception.reducer";
import AgentControlPanelReducer from "./agentControlPanel.reducer";
import WallboardReducer from "./wallboard.reducer";
import LiveQueueReducer from "./livequeue.reducer";
import SupervisorReportsReducer from "./supervisorReports.reducer";

const appReducers = combineReducers({
  Auth: AuthReducer,
  NumberManager: NumberManagerReducer,
  SuperVisor: SupervisorReducer,
  SupervisorQueue: SupervisorQueueReducer,
  ActiveSupervisorQueue: ActiveSupervisorQueueReducer,
  Sms: smsReducer,
  ReceptionReducer: ReceptionSockReducer,
  AgentControlPanelReducer: AgentControlPanelReducer,
  WallboardReducer: WallboardReducer,
  LiveQueueReducer: LiveQueueReducer,
  SupervisorReports: SupervisorReportsReducer,
});

// Call this on logout or whenever you need the redux state to reset - Amaan 
const rootReducer = (state: ReturnType<typeof appReducers> | undefined, action: any) => {
  if (action.type === "RESET_STATE") {
    state = undefined; // Reset the state to undefined, which resets it to the initial state.
  }
  return appReducers(state, action);
};


export default rootReducer;

export type RootState = ReturnType<typeof appReducers>;
